const SET_SESSIONS_FOR_NURSERY_BRANCH = (state, {data, nurseryBranchId}) => {
  state.sessions.items = data
  state.sessions.nurseryBranchId = nurseryBranchId
}

export default {
  SET_SESSIONS_FOR_NURSERY_BRANCH,
}